import React from "react";
import { Grid, Paper, Typography } from "@mui/material";

import GroupByPerson from "./GroupByPerson";

const PairingResults = ({ data }) => {
  const [view, setView] = React.useState("byAttendee");
  const [showAll, setShowAll] = React.useState(false);

  const renderResult = () => {
    if (data) {
      return (
        <>
          <Grid container justifyContent="space-between" alignItems="center">
            <Grid item>
              <Typography style={{ padding: 10 }}>Pairing Results</Typography>
            </Grid>
            {/* <Grid item>
              <FormControlLabel control={<Switch checked={showAll} onClick={() => setShowAll(!showAll)}/>} label="Show All" />
            </Grid> */}
            <Grid item xs={2}>
              {/* <Button
                variant="outlined"
                size="small"
                onClick={() => setManualPairOpen(true)}
              >
                pair
              </Button> */}
            </Grid>
            {window.innerWidth < 800 ? (
              <></>
            ) : (
              <Grid item xs={2}>
                {/* <Button onClick={() => print(true)}>Print</Button> */}
              </Grid>
            )}
          </Grid>
          {view === "byAttendee" ? (
            <GroupByPerson data={data.byAttendee} showAll={showAll}/>
          ) : (
            <Paper height={3} style={{ width: "100%" }}></Paper>
          )}
          {/* <ManualPair open={manualPairOpen} close={() => setManualPairOpen(false)} data={data}/> */}
        </>
      );
    } else {
      return <></>;
    }
  };

  return <>{renderResult()}</>;
};

export default PairingResults;
